module.exports = __webpack_public_path__ + "static/13-2-293d12141ac55fd03d152940fec1ac35.jpg";